import React, { Fragment as _, useContext } from 'react';

const AssessmentIntroduction = ({ children, ...props }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'red',
      }}
    >
      <h1>Assessment Introduction</h1>
    </div>
  );
};

export default AssessmentIntroduction;
